import React, { FC } from 'react'
import { Dropdown } from 'antd'
import { DropDownProps } from 'antd/lib/dropdown'
import { AutoTestsProps } from 'Types/autoTests'
import { Callback } from 'Src/types/utilTypes'
import { Id } from 'Types/aliases'

import { DropdownList, DropdownListItem } from './styled'

export enum DropdownPlacement {
	BOTTOM_LEFT = 'bottomLeft',
	BOTTOM_RIGHT = 'bottomRight',
	TOP_CENTER = 'topCenter',
}

interface DropdownProps extends Partial<DropDownProps>, AutoTestsProps {
	wrappedComponent: React.ReactNode
	list: {
		id: Id
		name: string | JSX.Element
		danger?: boolean
		dividerTop?: boolean
		dividerBottom?: boolean
		onClick: Callback
	}[]
	placement?: DropdownPlacement
	withContainer?: boolean
}

export const DropdownComponent: FC<DropdownProps> = ({
	wrappedComponent,
	placement = DropdownPlacement.BOTTOM_LEFT,
	list,
	withContainer = true,
}) => {
	const listElement = (
		<DropdownList>
			{list.map(({ id, name, danger, dividerTop = false, dividerBottom = false, onClick }) => (
				<DropdownListItem
					key={id}
					title={name}
					$danger={danger}
					$dividerTop={dividerTop}
					$dividerBottom={dividerBottom}
					onClick={onClick}
				>
					{name}
				</DropdownListItem>
			))}
		</DropdownList>
	)

	return (
		<Dropdown
			overlay={listElement}
			trigger={['click']}
			placement={placement}
			getPopupContainer={
				withContainer ? (triggerNode) => triggerNode.parentNode as HTMLDivElement : null
			}
		>
			{wrappedComponent}
		</Dropdown>
	)
}
